export default __webpack_public_path__ + "static/media/icon-arrow-down.8a427800.svg";